import { httpClient } from "./RestService";

export const getAll = async () => {
  return await httpClient().get("/v1/education/st/assmnt/list");
};

export const searchById = async (id) => {
  return await httpClient().get("/v1/education/st/assmnt/search/" + id);
};

export const enroll = async (assignmentId) => {
  return await httpClient().post("/v1/education/st/assmnt/enroll", {
    id: assignmentId,
  });
};

export const create = async (data) => {
  return await httpClient().post("/v1/education/st/assmnt/grp", data);
};

export const del = async (id) => {
  return await httpClient().delete("/v1/education/st/assmnt/" + id);
};

export const join = async (assignmentId, groupId) => {
  return await httpClient().post("/v1/education/st/assmnt/grp/join", {
    groupId,
    assignmentId,
  });
};

export const leave = async (groupId) => {
  return await httpClient().delete(
    "/v1/education/st/assmnt/grp/leave/" + groupId
  );
};

export const deleteGroup = async (groupId) => {
  return await httpClient().delete("/v1/education/st/assmnt/grp/" + groupId);
};

export const getAllGroups = async (assignmentId) => {
  return await httpClient().get(
    "/v1/education/st/assmnt/grp?assignmentId=" + assignmentId
  );
};

export const getAllQuestions = async (caseStudyId) => {
  return await httpClient().get(
    "/v1/education/st/assmnt/qs?caseStudyId=" + caseStudyId
  );
};

export const getFeedbacks = async (feedbackReqId) => {
  return await httpClient().get(
    "/v1/education/st/assmnt/feedback?reqId=" + feedbackReqId
  );
};

export const getAllQuestionAnswers = async (groupId, assignmentId) => {
  return await httpClient().get(
    "/v1/education/st/assmnt/grp/qans?groupId=" +
      groupId +
      "&assignmentId=" +
      assignmentId
  );
};

export const submitAnswer = async (data) => {
  return await httpClient().post("/v1/education/st/assmnt/grp/ans", data);
};

export const submitIndividualAnswer = async (data) => {
  return await httpClient().post("/v1/education/st/assmnt/ind/ans", data);
};

export const requestFeedback = async (data) => {
  return await httpClient().post("/v1/education/st/assmnt/fdbkreq", data);
};
